import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { DeploymentContext } from '../utilities/deployment-context/deployment-context.js';

@Injectable({ providedIn: 'root' })
export class InitializationGuard implements CanActivate {
	constructor(private context: DeploymentContext) {}

	canActivate(): boolean {
		return this.context.initializedSuccessfully;
	}
}
